import * as React from 'react'
import {Nullable} from '../../../../../app/TypeHelpers'
import {BlockSpacer} from '../../../../../styledComponents/ResponsiveConvenience'
import {APPLY_CATEGORY} from '../../../../../CodeMaster'
import {convertToRoomNumberForResident} from '../../../../common/util/Natutil'
import {
    NatResidentLoginInfoSessionStorageHelper,
    ResidentLoginInfoSessionStorageKey
} from '../../../../common/authentication/NatResidentLoginInfoSessionStorageHelper'
import {getFormattedDate} from '../helper/NatConstructionCompleteHelper'
import NatResidentApplicationDetailConfirmItem from '../../common/resident/NatResidentApplicationDetailConfirmItem'

interface Props {
    applicantFamilyName: Nullable<string>
    applicantFirstName: Nullable<string>
    contractorName: Nullable<string>
    constructionCompleteDate: Nullable<string>
    applyFlag?: boolean
}

const NatResidentConstructionCompleteConfirm = ({applyFlag = true, ...otherProps}: Props) => {
    const {
        applicantFamilyName, applicantFirstName, contractorName, constructionCompleteDate
    } = otherProps

    const applyCategoryLabel = APPLY_CATEGORY.CONSTRUCTION_COMPLETION.label
    const applicantRoom = NatResidentLoginInfoSessionStorageHelper
            .getStringItemOrNull(ResidentLoginInfoSessionStorageKey.SELECTED_CONDOMINIUM_NAME) + '　' +
        NatResidentLoginInfoSessionStorageHelper
            .getStringItemOrNull(ResidentLoginInfoSessionStorageKey.SELECTED_RIDGENAME) + ' ' +
        convertToRoomNumberForResident(
            NatResidentLoginInfoSessionStorageHelper
                .getStringItemOrNull(ResidentLoginInfoSessionStorageKey.SELECTED_ROOM_NUMBER)
        )
    const constructionCompleteDateLabel = (constructionCompleteDate) ? getFormattedDate(constructionCompleteDate) : ''
    const contractorNameLabel = (contractorName) ? contractorName : ''
    return (<>
        {applyFlag === true &&
            <>
                <NatResidentApplicationDetailConfirmItem
                    title={'申請区分'}
                    items={[applyCategoryLabel]}
                />
                <BlockSpacer height={'5px'}/>
                <NatResidentApplicationDetailConfirmItem
                    title={'申請者'}
                    items={[applicantRoom, `${applicantFamilyName} ${applicantFirstName}`]}
                />
            </>
        }
        <BlockSpacer height={'5px'}/>
        <NatResidentApplicationDetailConfirmItem
            title={'工事施工者'}
            items={[contractorNameLabel]}
        />
        <BlockSpacer height={'5px'}/>
        <NatResidentApplicationDetailConfirmItem
            title={'工事完了日'}
            items={[constructionCompleteDateLabel]}
        />
    </>)
}

NatResidentConstructionCompleteConfirm.displayName = 'NatResidentConstructionCompleteConfirm'
export default NatResidentConstructionCompleteConfirm